<template>

    <div class="breadcrumb d-inline-block">
        <a v-for="(value, i) in breadcrumb_array_object" :key="i" :href="value.href" :style="i !== 0 ? 'margin-left:4px;' : ''" v-html="value.name + ' ' + value.arrow"/>
    </div>

</template>

<script>
export default {
    props:[
        'breadcrumb',
    ],

    name:   'Breadcrumb',

    data(){
        return{
            breadcrumb_array_object:    this.breadcrumb,
        }
    },
    methods:{

    },
    mounted(){
    }
}
</script>